import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphabetOnly]'
})
export class AlphabetOnlyDirective {
  @HostListener('keypress', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (!event.key.match(/^[a-zA-Z\s]*$/)) {
      event.preventDefault();
    }
  }
}
